import React, { PureComponent } from 'react';
import { Image } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

//IMAGES
import ErrorIcon from "../images/svgs/Error.svg";

class Category extends PureComponent {
  redirectToDetail = () => {
    // console.log('props', this.props);
    this.props.history.push({
      pathname: `/clientwebsite2/category/${this.props.media.id}`,
      // Change later to /productDetail
      state: {
        media: this.props.media,
        whatsappLink: this.props.whatsappLink,
        businessName: this.props.businessName,
      },
    });
  };
  render() {
    const { selected, dashboard, currency, } = this.props;
    const price = this.props.media.prices && this.props.media.prices.length > 0 && this.props.media.prices.find(pr => pr.currency === currency)
    return (
      <div onClick={() => {
        if (dashboard) {
          this.props.addToCart(this.props.media)
        } else
          this.redirectToDetail()
      }} key={this.props.media.imageId} className="categoryContainer">
        {selected ?
          <Image
            className="notSelected"
            src={ErrorIcon}
          />
          : <div className="emptyDiv"></div>
        }
        <div className={`imageDiv ${selected ? "selectedImage" : ""}  ${!this.props.media.name && !price && "removeProductInfo"}`}>
          <Image src={this.props.media.media && this.props.media.media.length > 0 && this.props.media.media[0].url} alt={this.props.media.productName} />
        </div>
        {(this.props.media.name) &&
          <div className="prodInfo">
            <h4 className="productName">
              {this.props.media.name ? this.props.media.name : ''}
            </h4>
          </div>
        }
      </div>

    );
  }
}

export default withRouter(Category);



// WEBPACK FOOTER //
// ./src/components/Category.js